<div fxLayout="row" fxLayoutAlign="center center" class="color">
    <mat-card fxFlex="50">
        <form [formGroup]="loginShopForm" (ngSubmit)="login(loginShopForm.value)">
            <div fxLayout="column" fxLayoutAlign="center center">
                <img class="login-logo" src="assets/Images/coopexpress-logo.png?v=20260414" onerror="this.onerror=null;this.src='assets/Images/dely-logo.png';">
                <h2 class="cardHeader">Login de comercios</h2>
                <div fxLayout="column" fxLayoutAlign="center center" class="fields">
                    <mat-form-field appearance="outline">
                        <mat-label>Usuario</mat-label>
                        <input matInput type="email" formControlName="username">
                        <mat-error *ngIf="loginShopForm.controls['username'].hasError('required')">
                            Este campo es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Contraseña</mat-label>
                        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                        <button
                            mat-icon-button
                            matSuffix
                            type="button"
                            (click)="hidePassword = !hidePassword"
                            [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                        >
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                        <mat-error *ngIf="loginShopForm.controls['password'].hasError('required')">
                            Este campo es obligatorio
                        </mat-error>
                    </mat-form-field>
                    <button type="submit" mat-raised-button class="squared-btn">Ingresar</button>
                </div>
            </div>
        </form>
    </mat-card>

    <div fxLayout="column" fxLayoutAlign="center center" fxFlex="50">
    </div>
</div>